import { ReactNode, useEffect, useRef } from 'react';

import {
  OnboardingHighlightConfig,
  OnboardingHighlightName,
  useOnboardingHighLightContext,
} from 'contexts/onboardingHighlight';

type WrapperProps = {
  highlightName: OnboardingHighlightName;
  children: ReactNode;
  config?: OnboardingHighlightConfig;
};
const Wrapper = ({ highlightName, children, config }: WrapperProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { registerHighlight } = useOnboardingHighLightContext();

  useEffect(() => {
    registerHighlight({
      name: highlightName,
      measureCallback: () => {
        if (ref.current) {
          return ref.current.getBoundingClientRect();
        }
        return null;
      },
      config,
    });
  }, [config, highlightName, registerHighlight]);

  return <div ref={ref}>{children}</div>;
};

type Props = {
  highlightName: OnboardingHighlightName;
  children: ReactNode;
  config?: OnboardingHighlightConfig;
  active?: boolean;
};
export const OnboardingHighlightWrapper = ({
  children,
  active = true,
  ...rest
}: Props) => {
  if (active) {
    return <Wrapper {...rest}>{children}</Wrapper>;
  }

  return children;
};
